(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duna-customer-stories"] && !Shopify.designMode) return;
  try {
    
  class DunaStories extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('[data-track]');
      this.controls = this.querySelector('[data-controls]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    move(direction) {
      const width = this.track.firstElementChild?.getBoundingClientRect().width || this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      this.track.scrollBy({ left: direction * rtl * (width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const offset = Math.abs(this.track.scrollLeft);
      this.controls.hidden = max <= 2;
      this.previous.disabled = offset <= 5;
      this.next.disabled = offset >= max - 5;
    }
  }
  if (!customElements.get('duna-stories')) customElements.define('duna-stories', DunaStories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duna-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmt(cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function syncLabel(form) {
    var cb = form && form.querySelector('[data-ms-addon-check]');
    var root = form && form.closest('[data-ms-product]');
    if (!cb || !root) return;
    var active = root.querySelector('[data-ms-bundle].is-active');
    var label = form.querySelector('[data-ms-submit-label]');
    if (!active || !label || active.dataset.available === 'false') return;
    var cents = Number(active.dataset.price || 0) + (cb.checked ? Number(cb.dataset.addonPrice || 0) : 0);
    label.textContent = (root.getAttribute('data-button-label') || 'Add to cart') + ' - ' + fmt(cents);
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('[data-ms-addon-check]')) syncLabel(event.target.form);
  });
  document.addEventListener('click', function (event) {
    var bundle = event.target.closest && event.target.closest('[data-ms-bundle]');
    if (!bundle) return;
    var root = bundle.closest('[data-ms-product]');
    var form = root && root.querySelector('form[data-ms-product-form]');
    if (form) setTimeout(function () { syncLabel(form); }, 0);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[data-ms-product-form]')) return;
    var cb = form.querySelector('[data-ms-addon-check]');
    if (form.dataset.msAddonDone === '1') { form.dataset.msAddonDone = ''; return; }
    if (!cb || !cb.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(cb.value), quantity: 1 }] })
    }).catch(function () {}).then(function () {
      form.dataset.msAddonDone = '1';
      var btn = form.querySelector('[type="submit"]');
      if (form.requestSubmit) form.requestSubmit(btn || undefined); else if (btn) btn.click();
    });
  }, true);
})();
document.addEventListener('click', function (event) {
  var bundle = event.target.closest('[data-ms-bundle]');
  if (!bundle) return;
  var root = bundle.closest('[data-ms-product]');
  if (!root) return;
  var index = bundle.getAttribute('data-bundle-index');
  root.querySelectorAll('[data-ms-gets-for]').forEach(function (panel) {
    panel.hidden = panel.getAttribute('data-ms-gets-for') !== index;
  });
});
document.addEventListener('click', function (event) {
  var opener = event.target.closest('[data-ms-gets-open]');
  if (opener) {
    var dialog = document.getElementById(opener.getAttribute('data-ms-gets-open'));
    if (dialog && dialog.showModal) { dialog.showModal(); }
    return;
  }
  if (event.target.closest('[data-ms-gets-close]')) {
    var open = event.target.closest('dialog');
    if (open) open.close();
    return;
  }
  if (event.target.matches && event.target.matches('dialog.ms-gets__dialog')) {
    event.target.close();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
